import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useModalContext } from './modal-context-provider';

export type ModalFooterProps = React.HTMLAttributes<HTMLDivElement>;

export const ModalFooter = ({
  children,
  className,
  ...props
}: ModalFooterProps): React.ReactElement => {
  const classNames = classnames(className, 'airtame-modal__footer');
  const { disableLegacy } = useModalContext();
  useEffect(() => disableLegacy(), []);

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};
